module.exports = __webpack_public_path__ + "static/media/Wearpeachi_4_Pace Ultra High Waist 7_8 Tights in Chocolate.46c590b2.jpeg";